<template>
  <div v-if="loading"
       class="circular-loader">
    <base-circular-loader color="primary"
                          size="medium" />
  </div>

  <ul v-else
      class="device-list">
    <div class="device-list-title">
      {{ `${$t("installedDevices.title2")} ${usedInstalls}/${totalInstalls}` }}
    </div>
    <installed-device v-for="(device, index) in devices"
                      :key="index"
                      :device="device"
                      @removeDevice="removeDevice" />
  </ul>
</template>

<script>
  import InstalledDevice from './InstalledDevicesItem.vue'

  export default {
    components: {
      InstalledDevice
    },

    data() {
      return {
        loading: false
      }
    },

    created() {
      this.loadInstallsInfo()
    },

    methods: {
      ...mapActions('devices', {
        load: 'load'
      }),

      ...mapActions('children', {
        removeChildDevice: 'removeChildDevice'
      }),

      removeDevice(deviceId) {
        this.removeChildDevice(deviceId)
      },

      async loadInstallsInfo() {
        this.loading = true

        await this.load(this.currentUser.group_id)

        this.loading = false
      }
    },

    computed: {
      ...mapState('devices', [
        'usedInstalls',
        'totalInstalls'
      ]),

      ...mapGetters('children', {
        children: 'get'
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      devices() {
        return _.uniqBy(_.flatten(this.children.map(child => child.devices)), 'id')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .circular-loader {
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
  }

  .device-list {
    width: 100%;
    min-height: 400px;
    list-style: none;
    padding: 0;
    margin: 0;

    &-title {
      color: map-get($colors, primary);
      font-weight: bold;
      letter-spacing: 1px;
      margin-bottom: 32px;
    }
  }
</style>
